<template>
	<div class="nav-bar">
		<div class="fixed-nav-bar">
			<div class="left-view">
				<img class="" src="images/logo.png" alt="">
			</div>
			<div class="menu-list">
				<div :class="{item:true,active:item.active}" v-for="(item,index) in menuList" :key="item.pathName" @click="menuClickFun(index)">{{item.name}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: "navPC",
		props:{
			menuList: {
				type: Array,
				default(){
					return []
				}
			}
		},
		data (){
			return {
			}
		},methods:{
			menuClickFun (index){
				this.$emit("menuchange",{
					current: this.$attrs,
					detail:{
						value: index
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	.nav-bar,.fixed-nav-bar{
		width: 100%;
		height: 0.72rem;
		background: #FFFFFF;
	}
	.fixed-nav-bar{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #FFFFFF;
		box-shadow: 0 0 0.24rem 0 rgba(0,0,0,0.25);
	}
	.fixed-nav-bar>.left-view{
		padding-top: 0.04rem;
		width: 1rem;
		margin-right: 3.2rem;
		box-sizing: border-box;
	}
	.fixed-nav-bar>.left-view>img{
		width: 100%;
	}
	.fixed-nav-bar>.menu-list{
		height: 100%;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.fixed-nav-bar>.menu-list>.item{
		color: #3F3F3F;
		font-size: 0.18rem;
		font-weight:bold;
		flex-shrink: 0;
		margin-left: 0.32rem;
		cursor: pointer;
		padding: 0.04rem 0.12rem;
		box-sizing: border-box;
		user-select: none;
	}
	.fixed-nav-bar>.menu-list>.item:nth-of-type(1){
		margin-left: 0;
	}
	.fixed-nav-bar>.menu-list>.item.active{
		color: #4788F4;
	}
</style>
